import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// import { marketTrading, marketVietnam, marketWorld } from './marketConstants'

export const MarketStore = createSlice({
  name: 'MarketStore',
  initialState: {
    marketWorld: [],
    marketWorldFirst: true,
    marketVietnam: [],
    marketVietnamFirst: true,
    marketTrading: [],
    marketTradingFirst: true,
    marketCashflow: [],
    marketCashflowIndustry: {},
    marketCashflowStock: {},
    marketTransprobability: [],
    stockTicker: [],
  },
  reducers: {
    setMarketWorld: (state: any, actions: any) => {
      state.marketWorld = actions.payload
      state.marketWorldFirst = false
    },
    setMarketVietname: (state: any, actions: any) => {
      state.marketVietnam = actions.payload
    },
    setMarketTrading: (state: any, actions: any) => {
      state.marketTrading = actions.payload
    },
    setMarketCashflow: (state: any, actions: any) => {
      state.marketCashflow = actions.payload
    },
    setMarketCashflowIndustry: (state: any, actions: any) => {
      state.marketCashflowIndustry = actions.payload
    },
    setMarketCashflowStock: (state: any, actions: any) => {
      state.marketCashflowStock = actions.payload
    },
    setMarketTransprobability: (state: any, actions: any) => {
      state.marketTransprobability = actions.payload
    },
    setStockTicker: (state: any, actions: any) => {
      state.stockTicker = actions.payload
    },
  }
})

// Action creators are generated for each case reducer function
export const {
  setMarketWorld,
  setMarketVietname,
  setMarketTrading,
  setMarketCashflow,
  setMarketCashflowIndustry,
  setMarketCashflowStock,
  setMarketTransprobability,
  setStockTicker,
} = MarketStore.actions

export default MarketStore.reducer